// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__Iml1Y","headers":"otherPropertyItemNew_headers__5oTta","semiTitle":"otherPropertyItemNew_semiTitle__1YOXH"};